// Scoped JS: operate only inside #cvgcalc
const root = document.getElementById('cvgcalc');
if (root) {
  const el = id => root.querySelector('#' + id);
  const qsa = sel => Array.from(root.querySelectorAll(sel));

  function round(n, dp = 2) { const f = Math.pow(10, dp); return Math.round((n + Number.EPSILON) * f) / f; }
  function unitLabels() { return el('unitSystem').value === 'imperial' ? { mass: 'lb', vol: 'gal', smallVol: 'qt', length: 'in' } : { mass: 'kg', vol: 'L', smallVol: 'L', length: 'cm' }; }
  function toMetricMass(x) { return el('unitSystem').value === 'imperial' ? x * 0.45359237 : x; }
  function fromMetricMass(kg) { return el('unitSystem').value === 'imperial' ? kg / 0.45359237 : kg; }
  function toMetricVol(x) { return el('unitSystem').value === 'imperial' ? x * 3.785411784 : x; }
  function fromMetricVol(L) { return el('unitSystem').value === 'imperial' ? L / 3.785411784 : L; }
  function adjustDensityByPacking(d) { const p = el('packing').value; if (p === 'loose') return d * 0.9; if (p === 'firm') return d * 1.1; return d; }

  function vermGradeDensity() {
    const grade = el('vermGrade').value; // g/mL midpoints from ranges
    // Fine: 80–125 → 102.5 g/L; Medium: 67–103 → 85 g/L; Large: 60–100 → 80 g/L
    const mids = { fine: 0.1025, medium: 0.085, large: 0.08 };
    if (grade === 'custom') return parseFloat(el('densVerm').value || '0.085');
    return mids[grade] ?? 0.085;
  }

  function getDensities() {
    const coir = adjustDensityByPacking(parseFloat(el('densCoir')?.value || '0.16'));
    const vermBase = vermGradeDensity();
    const verm = adjustDensityByPacking(vermBase);
    const gypsum = adjustDensityByPacking(parseFloat(el('densGypsum')?.value || '0.85'));
    const water = 1.0; // kg/L
    return { coir, verm, gypsum, water };
  }

  // Fractions by weight of dry mix (10:10:1)
  const frac = { coir: 2000 / 4200, verm: 2000 / 4200, gypsum: 200 / 4200 };

  function calcVolumesFromMasses(coirKg, vermKg, gypKg, waterKg) {
    const d = getDensities();
    return { coirL: coirKg / d.coir, vermL: vermKg / d.verm, gypL: gypKg / d.gypsum, waterL: waterKg / d.water };
  }

  function renderResults(data, noteMsg = '') {
    const { mass, vol } = unitLabels();
    const tbody = el('resultRows'); tbody.innerHTML = '';
    const rows = [
      ['Coco coir', data.coirKg, data.coirL],
      ['Vermiculite', data.vermKg, data.vermL],
      ['Gypsum', data.gypKg, data.gypL],
      ['Water', data.waterKg, data.waterL]
    ];
    let totalMassKg = 0, totalVolL = 0;
    rows.forEach(([name, kg, L]) => {
      totalMassKg += kg; totalVolL += L;
      const tr = document.createElement('tr');
      const td1 = document.createElement('td'); td1.textContent = name; tr.appendChild(td1);
      const td2 = document.createElement('td'); td2.textContent = `${round(fromMetricMass(kg), 3)} ${mass}`; tr.appendChild(td2);
      const td3 = document.createElement('td'); td3.textContent = `${round(fromMetricVol(L), 3)} ${vol}`; tr.appendChild(td3);
      tbody.appendChild(tr);
    });
    el('totalWeightCell').textContent = `${round(fromMetricMass(totalMassKg), 3)} ${mass}`;
    el('totalVolumeCell').textContent = `${round(fromMetricVol(totalVolL), 3)} ${vol}`;
    el('results').style.display = 'block';
    el('notes').innerHTML = noteMsg;

    // Informational gypsum concentration (g/L of finished mix)
    const gypPerL = (data.gypKg * 1000) / (data.coirL + data.vermL + data.gypL + data.waterL);
    el('gypPerLNote').innerHTML = `Gypsum concentration ≈ <b>${round(gypPerL, 2)} g/L</b> of finished CVG (auto-updates with grade/packing/hydration).`;

    // Fixed newline here:
    const text = rows.map(([n, kg, L]) => `${n}: ${round(fromMetricMass(kg), 3)} ${mass} | ${round(fromMetricVol(L), 3)} ${vol}`).join('\\n')
      + `\\nTotal: ${round(fromMetricMass(totalMassKg), 3)} ${mass} | ${round(fromMetricVol(totalVolL), 3)} ${vol}`;
    el('copyBtn').onclick = () => {
      navigator.clipboard.writeText(text).then(() => {
        const old = el('copyBtn').textContent; el('copyBtn').textContent = 'Copied!'; setTimeout(() => el('copyBtn').textContent = old, 1200);
      });
    };
  }

  // Tabs
  qsa('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      qsa('.tab-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const id = btn.dataset.tab;
      qsa('section.tab').forEach(s => s.style.display = 'none');
      el(id).style.display = 'block';
    });
  });

  // A) By final weight
  el('calcByWeight').onclick = () => {
    const total = toMetricMass(parseFloat(el('targetTotalWeight').value || '0'));
    const alpha = parseFloat(el('moistureRatio').value || '3.809'); if (total <= 0 || alpha <= 0) { alert('Enter positive values.'); return; }
    const D = total / (1 + alpha); // kg dry
    const coirKg = D * frac.coir, vermKg = D * frac.verm, gypKg = D * frac.gypsum, waterKg = D * alpha;
    const vols = calcVolumesFromMasses(coirKg, vermKg, gypKg, waterKg);
    renderResults({ coirKg, vermKg, gypKg, waterKg, ...vols }, `Dry mass = ${round(fromMetricMass(D), 3)} ${unitLabels().mass}. Hydration ${alpha} L/kg.`);
  };

  // B) By ingredients (no water limiting)
  el('calcByIngredients').onclick = () => {
    const coirAvail = toMetricMass(parseFloat(el('haveCoir').value || '0'));
    const vermAvail = toMetricMass(parseFloat(el('haveVerm').value || '0'));
    const gypAvail = toMetricMass(parseFloat(el('haveGypsum').value || '0'));
    const alpha = parseFloat(el('moistureRatio2').value || '3.809'); if (coirAvail <= 0 || vermAvail <= 0 || gypAvail <= 0 || alpha <= 0) { alert('Enter positive values.'); return; }
    const kCoir = coirAvail / 10, kVerm = vermAvail / 10, kGyp = gypAvail / 1; let k = Math.min(kCoir, kVerm, kGyp);
    const D = 21 * k; // kg dry from solids only
    const coirKg = D * frac.coir, vermKg = D * frac.verm, gypKg = D * frac.gypsum, waterKg = D * alpha;
    const vols = calcVolumesFromMasses(coirKg, vermKg, gypKg, waterKg);
    const limiting = (k === kCoir) ? 'coir' : (k === kVerm ? 'verm' : 'gypsum');
    renderResults({ coirKg, vermKg, gypKg, waterKg, ...vols }, `Max batch from solids only. Limiting ingredient: <b>${limiting}</b>.`);
  };

  // C) By target volume
  el('calcByVolume').onclick = () => {
    const V = toMetricVol(parseFloat(el('targetVolume').value || '0'));
    const alpha = parseFloat(el('moistureRatio3').value || '3.809'); if (V <= 0 || alpha <= 0) { alert('Enter positive values.'); return; }
    const d = getDensities();
    const coeff = (frac.coir / d.coir) + (frac.verm / d.verm) + (frac.gypsum / d.gypsum) + (alpha / d.water);
    const D = V / coeff; // kg dry
    const coirKg = D * frac.coir, vermKg = D * frac.verm, gypKg = D * frac.gypsum, waterKg = D * alpha;
    const vols = calcVolumesFromMasses(coirKg, vermKg, gypKg, waterKg);
    renderResults({ coirKg, vermKg, gypKg, waterKg, ...vols }, `Solved from target volume using densities + hydration.`);
  };
}
